export default "__VITE_ASSET__B96$hDEB__"